import { __extends } from "tslib";
import { Event } from "./Event";
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: KeyboardEvent
var KeyboardEvent = /** @class */ (function (_super) {
    __extends(KeyboardEvent, _super);
    function KeyboardEvent(type, bubbles, cancelable, charCodeValue, keyCodeValue, keyLocationValue, ctrlKeyValue, altKeyValue, shiftKeyValue) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (charCodeValue === void 0) { charCodeValue = 0; }
        if (keyCodeValue === void 0) { keyCodeValue = 0; }
        if (keyLocationValue === void 0) { keyLocationValue = 0; }
        if (ctrlKeyValue === void 0) { ctrlKeyValue = false; }
        if (altKeyValue === void 0) { altKeyValue = false; }
        if (shiftKeyValue === void 0) { shiftKeyValue = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._charCode = charCodeValue >>> 0;
        _this._keyCode = keyCodeValue >>> 0;
        _this._keyLocation = keyLocationValue >>> 0;
        _this._ctrlKey = !!ctrlKeyValue;
        _this._altKey = !!altKeyValue;
        _this._shiftKey = !!shiftKeyValue;
        return _this;
    }
    Object.defineProperty(KeyboardEvent.prototype, "charCode", {
        get: function () {
            return this._charCode;
        },
        set: function (value) {
            this._charCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "keyCode", {
        get: function () {
            return this._keyCode;
        },
        set: function (value) {
            this._keyCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "keyLocation", {
        get: function () {
            return this._keyLocation;
        },
        set: function (value) {
            this._keyLocation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "ctrlKey", {
        get: function () {
            return this._ctrlKey;
        },
        set: function (value) {
            this._ctrlKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "altKey", {
        get: function () {
            return this._altKey;
        },
        set: function (value) {
            this._altKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "shiftKey", {
        get: function () {
            return this._shiftKey;
        },
        set: function (value) {
            this._shiftKey = value;
        },
        enumerable: true,
        configurable: true
    });
    KeyboardEvent.prototype.clone = function () {
        return new KeyboardEvent(this.type, this.bubbles, this.cancelable, this.charCode, this.keyCode, this.keyLocation, this.ctrlKey, this.altKey, this.shiftKey);
    };
    KeyboardEvent.prototype.toString = function () {
        return this.formatToString('KeyboardEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'charCode', 'keyCode', 'keyLocation', 'ctrlKey', 'altKey', 'shiftKey');
    };
    KeyboardEvent.prototype.updateAfterEvent = function () {
        this.sec.player.requestRendering();
    };
    KeyboardEvent.classInitializer = null;
    KeyboardEvent.classSymbols = null;
    KeyboardEvent.instanceSymbols = null;
    KeyboardEvent.KEY_DOWN = "keyDown";
    KeyboardEvent.KEY_UP = "keyUp";
    return KeyboardEvent;
}(Event));
export { KeyboardEvent };
